module.exports = __webpack_public_path__ + "img/riscv.e41bd166.png";